<template>

    <div class="image-list-parent">
        <!-- désolé... sinon, il me mettait un <div vide anyway... et j'avais besoin d'une classe -->
        <div
            v-for="image in list"
            :key="image.key" class="image-radios" :class=" props.field.show_labels ? ' has-labels ' : ' no-labels ' ">

            <input type="radio"
                   :id="image.key"
                   :name="field.key"
                   :value="image.value"
                   v-model="value" />
            <label :for="image.key" class="image-list-label">
                <span class="image-container">
                    <img :src="imageUrl(image, 'square')"/>
                </span>
                <span class="image-list-text-label" v-if="props.field.show_labels">{{ image.title }}</span>
            </label>
        </div>
    </div>

</template>

<script>
export default {
    name : "InputImageList",
}
</script>

<script setup>
import { watch, ref, computed } from "vue";
import { getValue, getList }    from "../composables/useData";
import { useStore }             from "vuex";

let props = defineProps( [ "field", "data", "datastore" ] );
let emits = defineEmits( [ "update" ] )
let store = useStore();
let value = ref(/*useData.*/getValue( props.field, store.state, "user.profile" ) );

let list = computed( () => /*useData.*/getList( props.field, props.data, props.datastore ) );

watch( value, () => emits( "update", { key : props.field.key, value : value.value } ) )

function imageUrl ( image, strFormatName )
{
    let formats      = (image?.image?.formats ?? []);
    let format       = formats.find( f => f.name === strFormatName );
    let formatSource = formats.find( f => f.name === "source" );

    return format ? format.url : (formatSource?.url ?? '');
}

function hasField (fields)
{
    let strKey = props.field.key;

    return fields.includes(strKey);
}

function getKey ()
{
    return props.field.key;
}

defineExpose({ hasField, getKey });

</script>
